/**
 * Translations for Consent Banner
 * GDPR-compliant wording - clear, concise, no dark patterns
 */

export const translations = {
  cs: {
    // Banner
    bannerTitle: 'Nastavení soukromí',
    bannerTitleWithCompany: '{company} - Nastavení soukromí',
    bannerText: 'Používáme cookies a podobné technologie pro analýzu návštěvnosti a personalizaci reklam. Vaše data můžeme sdílet s našimi partnery. Souhlas můžete kdykoli změnit.',
    learnMore: 'Zásady cookies',
    acceptAll: 'Povolit vše',
    rejectAll: 'Odmítnout vše',
    settings: 'Nastavení',

    // Modal
    settingsTitle: 'Nastavení cookies',
    settingsIntro: 'Vyberte, které cookies chcete povolit. Nezbytné cookies nelze vypnout - jsou nutné pro fungování webu. Svou volbu můžete kdykoli změnit kliknutím na ikonu v levém dolním rohu.',

    // Categories
    necessary: 'Nezbytné',
    necessaryDesc: 'Tyto cookies jsou nutné pro základní funkce webu jako přihlášení, nákupní košík nebo zabezpečení. Bez nich web nefunguje správně.',

    analytics: 'Analytické',
    analyticsDesc: 'Pomáhají nám pochopit, jak web používáte - které stránky navštěvujete, jak dlouho na nich zůstáváte. Data slouží ke zlepšení webu.',

    marketing: 'Marketingové',
    marketingDesc: 'Umožňují zobrazovat reklamy odpovídající vašim zájmům. Data mohou být sdílena s reklamními partnery jako Google nebo Meta (Facebook).',

    // Badges & Buttons
    alwaysActive: 'Vždy aktivní',
    saveSettings: 'Uložit moje volby',

    // Iframe placeholders
    contentBlocked: '{service} obsah je blokován',
    allowService: 'Povolit {service}',
    cookieSettings: 'Upravit cookies',
  },

  en: {
    bannerTitle: 'Privacy Settings',
    bannerTitleWithCompany: '{company} - Privacy Settings',
    bannerText: 'We use cookies and similar technologies to analyze traffic and personalize ads. Your data may be shared with our partners. You can change your consent at any time.',
    learnMore: 'Cookie Policy',
    acceptAll: 'Accept All',
    rejectAll: 'Reject All',
    settings: 'Customize',

    settingsTitle: 'Cookie Settings',
    settingsIntro: 'Choose which cookies you want to allow. Essential cookies cannot be disabled - they are required for the website to function. You can change your choices anytime by clicking the icon in the bottom left corner.',

    necessary: 'Essential',
    necessaryDesc: 'These cookies are necessary for basic website functions like login, shopping cart, or security. The website cannot function properly without them.',

    analytics: 'Analytics',
    analyticsDesc: 'Help us understand how you use the website - which pages you visit, how long you stay. Data is used to improve the website.',

    marketing: 'Marketing',
    marketingDesc: 'Enable us to show ads matching your interests. Data may be shared with advertising partners like Google or Meta (Facebook).',

    alwaysActive: 'Always Active',
    saveSettings: 'Save My Choices',

    contentBlocked: '{service} content is blocked',
    allowService: 'Allow {service}',
    cookieSettings: 'Manage cookies',
  },

  de: {
    bannerTitle: 'Datenschutzeinstellungen',
    bannerTitleWithCompany: '{company} - Datenschutzeinstellungen',
    bannerText: 'Wir verwenden Cookies und ähnliche Technologien zur Analyse des Datenverkehrs und zur Personalisierung von Werbung. Ihre Daten können mit unseren Partnern geteilt werden. Sie können Ihre Einwilligung jederzeit ändern.',
    learnMore: 'Cookie-Richtlinie',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Alle ablehnen',
    settings: 'Anpassen',

    settingsTitle: 'Cookie-Einstellungen',
    settingsIntro: 'Wählen Sie, welche Cookies Sie zulassen möchten. Notwendige Cookies können nicht deaktiviert werden - sie sind für die Funktion der Website erforderlich. Sie können Ihre Auswahl jederzeit ändern, indem Sie auf das Symbol unten links klicken.',

    necessary: 'Notwendig',
    necessaryDesc: 'Diese Cookies sind für grundlegende Website-Funktionen wie Anmeldung, Warenkorb oder Sicherheit erforderlich. Ohne sie funktioniert die Website nicht richtig.',

    analytics: 'Analyse',
    analyticsDesc: 'Helfen uns zu verstehen, wie Sie die Website nutzen - welche Seiten Sie besuchen, wie lange Sie bleiben. Daten werden zur Verbesserung der Website verwendet.',

    marketing: 'Marketing',
    marketingDesc: 'Ermöglichen uns, Werbung zu zeigen, die Ihren Interessen entspricht. Daten können mit Werbepartnern wie Google oder Meta (Facebook) geteilt werden.',

    alwaysActive: 'Immer aktiv',
    saveSettings: 'Meine Auswahl speichern',

    contentBlocked: '{service} Inhalt ist blockiert',
    allowService: '{service} erlauben',
    cookieSettings: 'Cookies verwalten',
  },

  pl: {
    bannerTitle: 'Ustawienia prywatności',
    bannerTitleWithCompany: '{company} - Ustawienia prywatności',
    bannerText: 'Używamy plików cookie i podobnych technologii do analizy ruchu i personalizacji reklam. Twoje dane mogą być udostępniane naszym partnerom. Możesz zmienić swoją zgodę w dowolnym momencie.',
    learnMore: 'Polityka cookies',
    acceptAll: 'Zaakceptuj wszystkie',
    rejectAll: 'Odrzuć wszystkie',
    settings: 'Dostosuj',

    settingsTitle: 'Ustawienia plików cookie',
    settingsIntro: 'Wybierz, które pliki cookie chcesz zezwolić. Niezbędne pliki cookie nie mogą być wyłączone - są wymagane do działania strony. Możesz zmienić swój wybór w dowolnym momencie, klikając ikonę w lewym dolnym rogu.',

    necessary: 'Niezbędne',
    necessaryDesc: 'Te pliki cookie są niezbędne do podstawowych funkcji strony, takich jak logowanie, koszyk lub bezpieczeństwo. Strona nie może działać prawidłowo bez nich.',

    analytics: 'Analityczne',
    analyticsDesc: 'Pomagają nam zrozumieć, jak korzystasz ze strony - które strony odwiedzasz, jak długo zostajesz. Dane służą do ulepszania strony.',

    marketing: 'Marketingowe',
    marketingDesc: 'Umożliwiają wyświetlanie reklam odpowiadających Twoim zainteresowaniom. Dane mogą być udostępniane partnerom reklamowym, takim jak Google lub Meta (Facebook).',

    alwaysActive: 'Zawsze aktywne',
    saveSettings: 'Zapisz moje wybory',

    contentBlocked: 'Treść {service} jest zablokowana',
    allowService: 'Zezwól na {service}',
    cookieSettings: 'Zarządzaj cookies',
  },

  sk: {
    bannerTitle: 'Nastavenia súkromia',
    bannerTitleWithCompany: '{company} - Nastavenia súkromia',
    bannerText: 'Používame cookies a podobné technológie na analýzu návštevnosti a personalizáciu reklám. Vaše údaje môžeme zdieľať s našimi partnermi. Súhlas môžete kedykoľvek zmeniť.',
    learnMore: 'Zásady cookies',
    acceptAll: 'Povoliť všetko',
    rejectAll: 'Odmietnuť všetko',
    settings: 'Nastaviť',

    settingsTitle: 'Nastavenia cookies',
    settingsIntro: 'Vyberte, ktoré cookies chcete povoliť. Nevyhnutné cookies nie je možné vypnúť - sú potrebné pre fungovanie webu. Svoju voľbu môžete kedykoľvek zmeniť kliknutím na ikonu v ľavom dolnom rohu.',

    necessary: 'Nevyhnutné',
    necessaryDesc: 'Tieto cookies sú potrebné pre základné funkcie webu ako prihlásenie, nákupný košík alebo zabezpečenie. Bez nich web nefunguje správne.',

    analytics: 'Analytické',
    analyticsDesc: 'Pomáhajú nám pochopiť, ako web používate - ktoré stránky navštevujete, ako dlho na nich zostávate. Údaje slúžia na zlepšenie webu.',

    marketing: 'Marketingové',
    marketingDesc: 'Umožňujú zobrazovať reklamy zodpovedajúce vašim záujmom. Údaje môžu byť zdieľané s reklamnými partnermi ako Google alebo Meta (Facebook).',

    alwaysActive: 'Vždy aktívne',
    saveSettings: 'Uložiť moje voľby',

    contentBlocked: '{service} obsah je blokovaný',
    allowService: 'Povoliť {service}',
    cookieSettings: 'Upraviť cookies',
  },

  si: {
    bannerTitle: 'Nastavitve zasebnosti',
    bannerTitleWithCompany: '{company} - Nastavitve zasebnosti',
    bannerText: 'Uporabljamo piškotke in podobne tehnologije za analizo prometa in personalizacijo oglasov. Vaši podatki so lahko deljeni z našimi partnerji. Privolitev lahko kadar koli spremenite.',
    learnMore: 'Pravilnik o piškotkih',
    acceptAll: 'Sprejmi vse',
    rejectAll: 'Zavrni vse',
    settings: 'Prilagodi',

    settingsTitle: 'Nastavitve piškotkov',
    settingsIntro: 'Izberite, katere piškotke želite dovoliti. Nujnih piškotkov ni mogoče onemogočiti - so potrebni za delovanje spletne strani. Svojo izbiro lahko kadar koli spremenite s klikom na ikono v spodnjem levem kotu.',

    necessary: 'Nujni',
    necessaryDesc: 'Ti piškotki so potrebni za osnovne funkcije spletne strani, kot so prijava, nakupovalna košarica ali varnost. Brez njih spletna stran ne deluje pravilno.',

    analytics: 'Analitični',
    analyticsDesc: 'Pomagajo nam razumeti, kako uporabljate spletno stran - katere strani obiščete, kako dolgo ostanete. Podatki se uporabljajo za izboljšanje spletne strani.',

    marketing: 'Trženjski',
    marketingDesc: 'Omogočajo prikazovanje oglasov, ki ustrezajo vašim interesom. Podatki so lahko deljeni z oglaševalskimi partnerji, kot sta Google ali Meta (Facebook).',

    alwaysActive: 'Vedno aktivno',
    saveSettings: 'Shrani moje izbire',

    contentBlocked: 'Vsebina {service} je blokirana',
    allowService: 'Dovoli {service}',
    cookieSettings: 'Upravljaj piškotke',
  },

  es: {
    bannerTitle: 'Configuración de privacidad',
    bannerTitleWithCompany: '{company} - Configuración de privacidad',
    bannerText: 'Utilizamos cookies y tecnologías similares para analizar el tráfico y personalizar anuncios. Sus datos pueden compartirse con nuestros socios. Puede cambiar su consentimiento en cualquier momento.',
    learnMore: 'Política de cookies',
    acceptAll: 'Aceptar todo',
    rejectAll: 'Rechazar todo',
    settings: 'Personalizar',

    settingsTitle: 'Configuración de cookies',
    settingsIntro: 'Elija qué cookies desea permitir. Las cookies esenciales no se pueden deshabilitar - son necesarias para el funcionamiento del sitio web. Puede cambiar sus opciones en cualquier momento haciendo clic en el icono en la esquina inferior izquierda.',

    necessary: 'Esenciales',
    necessaryDesc: 'Estas cookies son necesarias para funciones básicas del sitio web como inicio de sesión, carrito de compras o seguridad. El sitio web no puede funcionar correctamente sin ellas.',

    analytics: 'Analíticas',
    analyticsDesc: 'Nos ayudan a entender cómo usa el sitio web - qué páginas visita, cuánto tiempo permanece. Los datos se utilizan para mejorar el sitio web.',

    marketing: 'Marketing',
    marketingDesc: 'Permiten mostrar anuncios que coinciden con sus intereses. Los datos pueden compartirse con socios publicitarios como Google o Meta (Facebook).',

    alwaysActive: 'Siempre activo',
    saveSettings: 'Guardar mis opciones',

    contentBlocked: 'El contenido de {service} está bloqueado',
    allowService: 'Permitir {service}',
    cookieSettings: 'Gestionar cookies',
  },

  hu: {
    bannerTitle: 'Adatvédelmi beállítások',
    bannerTitleWithCompany: '{company} - Adatvédelmi beállítások',
    bannerText: 'Sütiket és hasonló technológiákat használunk a forgalom elemzésére és a hirdetések személyre szabására. Adatait megoszthatjuk partnereinkkel. Hozzájárulását bármikor módosíthatja.',
    learnMore: 'Süti szabályzat',
    acceptAll: 'Összes elfogadása',
    rejectAll: 'Összes elutasítása',
    settings: 'Testreszabás',

    settingsTitle: 'Süti beállítások',
    settingsIntro: 'Válassza ki, mely sütiket szeretné engedélyezni. Az alapvető sütik nem tilthatók le - szükségesek a weboldal működéséhez. Választását bármikor módosíthatja a bal alsó sarokban lévő ikonra kattintva.',

    necessary: 'Szükséges',
    necessaryDesc: 'Ezek a sütik szükségesek a weboldal alapvető funkcióihoz, mint a bejelentkezés, kosár vagy biztonság. A weboldal nélkülük nem működik megfelelően.',

    analytics: 'Analitikai',
    analyticsDesc: 'Segítenek megérteni, hogyan használja a weboldalt - mely oldalakat látogatja, mennyi ideig marad. Az adatok a weboldal fejlesztésére szolgálnak.',

    marketing: 'Marketing',
    marketingDesc: 'Lehetővé teszik az érdeklődésének megfelelő hirdetések megjelenítését. Az adatok megoszthatók hirdetési partnerekkel, mint a Google vagy Meta (Facebook).',

    alwaysActive: 'Mindig aktív',
    saveSettings: 'Választásaim mentése',

    contentBlocked: 'A {service} tartalom blokkolva van',
    allowService: '{service} engedélyezése',
    cookieSettings: 'Sütik kezelése',
  },

  // French
  fr: {
    bannerTitle: 'Paramètres de confidentialité',
    bannerTitleWithCompany: '{company} - Paramètres de confidentialité',
    bannerText: 'Nous utilisons des cookies et des technologies similaires pour analyser le trafic et personnaliser les publicités. Vos données peuvent être partagées avec nos partenaires. Vous pouvez modifier votre consentement à tout moment.',
    learnMore: 'Politique de cookies',
    acceptAll: 'Tout accepter',
    rejectAll: 'Tout refuser',
    settings: 'Personnaliser',
    settingsTitle: 'Paramètres des cookies',
    settingsIntro: 'Choisissez les cookies que vous souhaitez autoriser. Les cookies essentiels ne peuvent pas être désactivés - ils sont nécessaires au fonctionnement du site. Vous pouvez modifier vos choix à tout moment en cliquant sur l\'icône en bas à gauche.',
    necessary: 'Essentiels',
    necessaryDesc: 'Ces cookies sont nécessaires aux fonctions de base du site comme la connexion, le panier ou la sécurité. Le site ne peut pas fonctionner correctement sans eux.',
    analytics: 'Analytiques',
    analyticsDesc: 'Nous aident à comprendre comment vous utilisez le site - quelles pages vous visitez, combien de temps vous restez. Les données servent à améliorer le site.',
    marketing: 'Marketing',
    marketingDesc: 'Permettent d\'afficher des publicités correspondant à vos intérêts. Les données peuvent être partagées avec des partenaires publicitaires comme Google ou Meta (Facebook).',
    alwaysActive: 'Toujours actif',
    saveSettings: 'Enregistrer mes choix',
    contentBlocked: 'Le contenu {service} est bloqué',
    allowService: 'Autoriser {service}',
    cookieSettings: 'Gérer les cookies',
  },

  // Italian
  it: {
    bannerTitle: 'Impostazioni privacy',
    bannerTitleWithCompany: '{company} - Impostazioni privacy',
    bannerText: 'Utilizziamo cookie e tecnologie simili per analizzare il traffico e personalizzare gli annunci. I tuoi dati possono essere condivisi con i nostri partner. Puoi modificare il tuo consenso in qualsiasi momento.',
    learnMore: 'Informativa cookie',
    acceptAll: 'Accetta tutto',
    rejectAll: 'Rifiuta tutto',
    settings: 'Personalizza',
    settingsTitle: 'Impostazioni cookie',
    settingsIntro: 'Scegli quali cookie vuoi consentire. I cookie essenziali non possono essere disabilitati - sono necessari per il funzionamento del sito. Puoi modificare le tue scelte in qualsiasi momento cliccando sull\'icona in basso a sinistra.',
    necessary: 'Essenziali',
    necessaryDesc: 'Questi cookie sono necessari per le funzioni di base del sito come login, carrello o sicurezza. Il sito non può funzionare correttamente senza di essi.',
    analytics: 'Analitici',
    analyticsDesc: 'Ci aiutano a capire come usi il sito - quali pagine visiti, quanto tempo rimani. I dati servono a migliorare il sito.',
    marketing: 'Marketing',
    marketingDesc: 'Permettono di mostrare annunci corrispondenti ai tuoi interessi. I dati possono essere condivisi con partner pubblicitari come Google o Meta (Facebook).',
    alwaysActive: 'Sempre attivo',
    saveSettings: 'Salva le mie scelte',
    contentBlocked: 'Il contenuto {service} è bloccato',
    allowService: 'Consenti {service}',
    cookieSettings: 'Gestisci cookie',
  },

  // Portuguese
  pt: {
    bannerTitle: 'Definições de privacidade',
    bannerTitleWithCompany: '{company} - Definições de privacidade',
    bannerText: 'Utilizamos cookies e tecnologias semelhantes para analisar o tráfego e personalizar anúncios. Os seus dados podem ser partilhados com os nossos parceiros. Pode alterar o seu consentimento a qualquer momento.',
    learnMore: 'Política de cookies',
    acceptAll: 'Aceitar tudo',
    rejectAll: 'Rejeitar tudo',
    settings: 'Personalizar',
    settingsTitle: 'Definições de cookies',
    settingsIntro: 'Escolha os cookies que deseja permitir. Os cookies essenciais não podem ser desativados - são necessários para o funcionamento do site. Pode alterar as suas escolhas a qualquer momento clicando no ícone no canto inferior esquerdo.',
    necessary: 'Essenciais',
    necessaryDesc: 'Estes cookies são necessários para funções básicas do site como login, carrinho ou segurança. O site não funciona corretamente sem eles.',
    analytics: 'Analíticos',
    analyticsDesc: 'Ajudam-nos a compreender como usa o site - que páginas visita, quanto tempo permanece. Os dados servem para melhorar o site.',
    marketing: 'Marketing',
    marketingDesc: 'Permitem mostrar anúncios que correspondem aos seus interesses. Os dados podem ser partilhados com parceiros de publicidade como Google ou Meta (Facebook).',
    alwaysActive: 'Sempre ativo',
    saveSettings: 'Guardar as minhas escolhas',
    contentBlocked: 'O conteúdo {service} está bloqueado',
    allowService: 'Permitir {service}',
    cookieSettings: 'Gerir cookies',
  },

  // Dutch
  nl: {
    bannerTitle: 'Privacy-instellingen',
    bannerTitleWithCompany: '{company} - Privacy-instellingen',
    bannerText: 'Wij gebruiken cookies en vergelijkbare technologieën om verkeer te analyseren en advertenties te personaliseren. Uw gegevens kunnen worden gedeeld met onze partners. U kunt uw toestemming op elk moment wijzigen.',
    learnMore: 'Cookiebeleid',
    acceptAll: 'Alles accepteren',
    rejectAll: 'Alles weigeren',
    settings: 'Aanpassen',
    settingsTitle: 'Cookie-instellingen',
    settingsIntro: 'Kies welke cookies u wilt toestaan. Essentiële cookies kunnen niet worden uitgeschakeld - ze zijn nodig voor de werking van de website. U kunt uw keuzes op elk moment wijzigen door op het pictogram linksonder te klikken.',
    necessary: 'Essentieel',
    necessaryDesc: 'Deze cookies zijn nodig voor basisfuncties van de website zoals inloggen, winkelwagen of beveiliging. De website kan niet goed functioneren zonder hen.',
    analytics: 'Analytisch',
    analyticsDesc: 'Helpen ons te begrijpen hoe u de website gebruikt - welke pagina\'s u bezoekt, hoe lang u blijft. Gegevens dienen om de website te verbeteren.',
    marketing: 'Marketing',
    marketingDesc: 'Maken het mogelijk advertenties te tonen die overeenkomen met uw interesses. Gegevens kunnen worden gedeeld met advertentiepartners zoals Google of Meta (Facebook).',
    alwaysActive: 'Altijd actief',
    saveSettings: 'Mijn keuzes opslaan',
    contentBlocked: '{service} inhoud is geblokkeerd',
    allowService: '{service} toestaan',
    cookieSettings: 'Cookies beheren',
  },

  // Swedish
  sv: {
    bannerTitle: 'Sekretessinställningar',
    bannerTitleWithCompany: '{company} - Sekretessinställningar',
    bannerText: 'Vi använder cookies och liknande tekniker för att analysera trafik och personanpassa annonser. Dina uppgifter kan delas med våra partners. Du kan ändra ditt samtycke när som helst.',
    learnMore: 'Cookiepolicy',
    acceptAll: 'Acceptera alla',
    rejectAll: 'Avvisa alla',
    settings: 'Anpassa',
    settingsTitle: 'Cookieinställningar',
    settingsIntro: 'Välj vilka cookies du vill tillåta. Nödvändiga cookies kan inte inaktiveras - de krävs för att webbplatsen ska fungera. Du kan ändra dina val när som helst genom att klicka på ikonen längst ner till vänster.',
    necessary: 'Nödvändiga',
    necessaryDesc: 'Dessa cookies är nödvändiga för grundläggande webbplatsfunktioner som inloggning, kundvagn eller säkerhet. Webbplatsen kan inte fungera korrekt utan dem.',
    analytics: 'Analytiska',
    analyticsDesc: 'Hjälper oss att förstå hur du använder webbplatsen - vilka sidor du besöker, hur länge du stannar. Data används för att förbättra webbplatsen.',
    marketing: 'Marknadsföring',
    marketingDesc: 'Gör det möjligt att visa annonser som matchar dina intressen. Data kan delas med annonspartners som Google eller Meta (Facebook).',
    alwaysActive: 'Alltid aktiv',
    saveSettings: 'Spara mina val',
    contentBlocked: '{service}-innehåll är blockerat',
    allowService: 'Tillåt {service}',
    cookieSettings: 'Hantera cookies',
  },

  // Danish
  da: {
    bannerTitle: 'Privatlivsindstillinger',
    bannerTitleWithCompany: '{company} - Privatlivsindstillinger',
    bannerText: 'Vi bruger cookies og lignende teknologier til at analysere trafik og personliggøre annoncer. Dine data kan deles med vores partnere. Du kan ændre dit samtykke når som helst.',
    learnMore: 'Cookiepolitik',
    acceptAll: 'Accepter alle',
    rejectAll: 'Afvis alle',
    settings: 'Tilpas',
    settingsTitle: 'Cookieindstillinger',
    settingsIntro: 'Vælg hvilke cookies du vil tillade. Nødvendige cookies kan ikke deaktiveres - de er nødvendige for at hjemmesiden fungerer. Du kan ændre dine valg når som helst ved at klikke på ikonet nederst til venstre.',
    necessary: 'Nødvendige',
    necessaryDesc: 'Disse cookies er nødvendige for grundlæggende hjemmesidefunktioner som login, indkøbskurv eller sikkerhed. Hjemmesiden kan ikke fungere korrekt uden dem.',
    analytics: 'Analytiske',
    analyticsDesc: 'Hjælper os med at forstå, hvordan du bruger hjemmesiden - hvilke sider du besøger, hvor længe du bliver. Data bruges til at forbedre hjemmesiden.',
    marketing: 'Marketing',
    marketingDesc: 'Gør det muligt at vise annoncer, der matcher dine interesser. Data kan deles med annoncepartnere som Google eller Meta (Facebook).',
    alwaysActive: 'Altid aktiv',
    saveSettings: 'Gem mine valg',
    contentBlocked: '{service} indhold er blokeret',
    allowService: 'Tillad {service}',
    cookieSettings: 'Administrer cookies',
  },

  // Finnish
  fi: {
    bannerTitle: 'Tietosuoja-asetukset',
    bannerTitleWithCompany: '{company} - Tietosuoja-asetukset',
    bannerText: 'Käytämme evästeitä ja vastaavia tekniikoita liikenteen analysointiin ja mainosten personointiin. Tietojasi voidaan jakaa kumppaneidemme kanssa. Voit muuttaa suostumustasi milloin tahansa.',
    learnMore: 'Evästekäytäntö',
    acceptAll: 'Hyväksy kaikki',
    rejectAll: 'Hylkää kaikki',
    settings: 'Mukauta',
    settingsTitle: 'Evästeasetukset',
    settingsIntro: 'Valitse mitkä evästeet haluat sallia. Välttämättömiä evästeitä ei voi poistaa käytöstä - ne ovat välttämättömiä sivuston toiminnalle. Voit muuttaa valintojasi milloin tahansa napsauttamalla kuvaketta vasemmassa alakulmassa.',
    necessary: 'Välttämättömät',
    necessaryDesc: 'Nämä evästeet ovat välttämättömiä sivuston perustoiminnoille kuten kirjautuminen, ostoskori tai turvallisuus. Sivusto ei voi toimia kunnolla ilman niitä.',
    analytics: 'Analyyttiset',
    analyticsDesc: 'Auttavat meitä ymmärtämään miten käytät sivustoa - mitä sivuja vierailet, kuinka kauan viivyt. Tietoja käytetään sivuston parantamiseen.',
    marketing: 'Markkinointi',
    marketingDesc: 'Mahdollistavat kiinnostuksiasi vastaavien mainosten näyttämisen. Tietoja voidaan jakaa mainoskumppanien kuten Googlen tai Metan (Facebook) kanssa.',
    alwaysActive: 'Aina aktiivinen',
    saveSettings: 'Tallenna valintani',
    contentBlocked: '{service}-sisältö on estetty',
    allowService: 'Salli {service}',
    cookieSettings: 'Hallitse evästeitä',
  },

  // Greek
  el: {
    bannerTitle: 'Ρυθμίσεις απορρήτου',
    bannerTitleWithCompany: '{company} - Ρυθμίσεις απορρήτου',
    bannerText: 'Χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες για την ανάλυση της επισκεψιμότητας και την εξατομίκευση διαφημίσεων. Τα δεδομένα σας μπορεί να κοινοποιηθούν στους συνεργάτες μας. Μπορείτε να αλλάξετε τη συγκατάθεσή σας ανά πάσα στιγμή.',
    learnMore: 'Πολιτική cookies',
    acceptAll: 'Αποδοχή όλων',
    rejectAll: 'Απόρριψη όλων',
    settings: 'Προσαρμογή',
    settingsTitle: 'Ρυθμίσεις cookies',
    settingsIntro: 'Επιλέξτε ποια cookies θέλετε να επιτρέψετε. Τα απαραίτητα cookies δεν μπορούν να απενεργοποιηθούν - είναι απαραίτητα για τη λειτουργία του ιστότοπου. Μπορείτε να αλλάξετε τις επιλογές σας ανά πάσα στιγμή κάνοντας κλικ στο εικονίδιο κάτω αριστερά.',
    necessary: 'Απαραίτητα',
    necessaryDesc: 'Αυτά τα cookies είναι απαραίτητα για βασικές λειτουργίες του ιστότοπου όπως σύνδεση, καλάθι αγορών ή ασφάλεια. Ο ιστότοπος δεν μπορεί να λειτουργήσει σωστά χωρίς αυτά.',
    analytics: 'Αναλυτικά',
    analyticsDesc: 'Μας βοηθούν να κατανοήσουμε πώς χρησιμοποιείτε τον ιστότοπο - ποιες σελίδες επισκέπτεστε, πόσο καιρό μένετε. Τα δεδομένα χρησιμοποιούνται για τη βελτίωση του ιστότοπου.',
    marketing: 'Μάρκετινγκ',
    marketingDesc: 'Επιτρέπουν την εμφάνιση διαφημίσεων που ταιριάζουν με τα ενδιαφέροντά σας. Τα δεδομένα μπορεί να κοινοποιηθούν σε διαφημιστικούς συνεργάτες όπως η Google ή η Meta (Facebook).',
    alwaysActive: 'Πάντα ενεργό',
    saveSettings: 'Αποθήκευση επιλογών',
    contentBlocked: 'Το περιεχόμενο {service} είναι αποκλεισμένο',
    allowService: 'Να επιτραπεί {service}',
    cookieSettings: 'Διαχείριση cookies',
  },

  // Romanian
  ro: {
    bannerTitle: 'Setări de confidențialitate',
    bannerTitleWithCompany: '{company} - Setări de confidențialitate',
    bannerText: 'Folosim cookie-uri și tehnologii similare pentru a analiza traficul și a personaliza reclamele. Datele dvs. pot fi partajate cu partenerii noștri. Puteți modifica consimțământul în orice moment.',
    learnMore: 'Politica cookie',
    acceptAll: 'Acceptă toate',
    rejectAll: 'Respinge toate',
    settings: 'Personalizează',
    settingsTitle: 'Setări cookie',
    settingsIntro: 'Alegeți ce cookie-uri doriți să permiteți. Cookie-urile esențiale nu pot fi dezactivate - sunt necesare pentru funcționarea site-ului. Puteți modifica alegerile în orice moment făcând clic pe pictograma din colțul din stânga jos.',
    necessary: 'Esențiale',
    necessaryDesc: 'Aceste cookie-uri sunt necesare pentru funcțiile de bază ale site-ului precum autentificare, coș de cumpărături sau securitate. Site-ul nu poate funcționa corect fără ele.',
    analytics: 'Analitice',
    analyticsDesc: 'Ne ajută să înțelegem cum folosiți site-ul - ce pagini vizitați, cât timp rămâneți. Datele servesc la îmbunătățirea site-ului.',
    marketing: 'Marketing',
    marketingDesc: 'Permit afișarea de reclame care corespund intereselor dvs. Datele pot fi partajate cu parteneri de publicitate precum Google sau Meta (Facebook).',
    alwaysActive: 'Mereu activ',
    saveSettings: 'Salvează alegerile mele',
    contentBlocked: 'Conținutul {service} este blocat',
    allowService: 'Permite {service}',
    cookieSettings: 'Gestionează cookies',
  },

  // Bulgarian
  bg: {
    bannerTitle: 'Настройки за поверителност',
    bannerTitleWithCompany: '{company} - Настройки за поверителност',
    bannerText: 'Използваме бисквитки и подобни технологии за анализ на трафика и персонализиране на реклами. Данните ви могат да бъдат споделени с нашите партньори. Можете да промените съгласието си по всяко време.',
    learnMore: 'Политика за бисквитки',
    acceptAll: 'Приеми всички',
    rejectAll: 'Откажи всички',
    settings: 'Персонализирай',
    settingsTitle: 'Настройки на бисквитките',
    settingsIntro: 'Изберете кои бисквитки искате да разрешите. Необходимите бисквитки не могат да бъдат деактивирани - те са необходими за работата на сайта. Можете да промените изборите си по всяко време, като кликнете върху иконата долу вляво.',
    necessary: 'Необходими',
    necessaryDesc: 'Тези бисквитки са необходими за основни функции на сайта като вход, кошница или сигурност. Сайтът не може да работи правилно без тях.',
    analytics: 'Аналитични',
    analyticsDesc: 'Помагат ни да разберем как използвате сайта - кои страници посещавате, колко време оставате. Данните служат за подобряване на сайта.',
    marketing: 'Маркетингови',
    marketingDesc: 'Позволяват показването на реклами, съответстващи на интересите ви. Данните могат да бъдат споделени с рекламни партньори като Google или Meta (Facebook).',
    alwaysActive: 'Винаги активен',
    saveSettings: 'Запази моите избори',
    contentBlocked: 'Съдържанието на {service} е блокирано',
    allowService: 'Разреши {service}',
    cookieSettings: 'Управление на бисквитките',
  },

  // Croatian
  hr: {
    bannerTitle: 'Postavke privatnosti',
    bannerTitleWithCompany: '{company} - Postavke privatnosti',
    bannerText: 'Koristimo kolačiće i slične tehnologije za analizu prometa i personalizaciju oglasa. Vaši podaci mogu biti podijeljeni s našim partnerima. Privolu možete promijeniti u bilo kojem trenutku.',
    learnMore: 'Politika kolačića',
    acceptAll: 'Prihvati sve',
    rejectAll: 'Odbij sve',
    settings: 'Prilagodi',
    settingsTitle: 'Postavke kolačića',
    settingsIntro: 'Odaberite koje kolačiće želite dopustiti. Nužni kolačići ne mogu se onemogućiti - potrebni su za rad web stranice. Svoje izbore možete promijeniti u bilo kojem trenutku klikom na ikonu u donjem lijevom kutu.',
    necessary: 'Nužni',
    necessaryDesc: 'Ovi kolačići su potrebni za osnovne funkcije web stranice poput prijave, košarice ili sigurnosti. Web stranica ne može ispravno funkcionirati bez njih.',
    analytics: 'Analitički',
    analyticsDesc: 'Pomažu nam razumjeti kako koristite web stranicu - koje stranice posjećujete, koliko dugo ostajete. Podaci služe za poboljšanje web stranice.',
    marketing: 'Marketinški',
    marketingDesc: 'Omogućuju prikazivanje oglasa koji odgovaraju vašim interesima. Podaci se mogu dijeliti s oglašivačkim partnerima poput Googlea ili Mete (Facebook).',
    alwaysActive: 'Uvijek aktivno',
    saveSettings: 'Spremi moje izbore',
    contentBlocked: 'Sadržaj {service} je blokiran',
    allowService: 'Dopusti {service}',
    cookieSettings: 'Upravljaj kolačićima',
  },

  // Estonian
  et: {
    bannerTitle: 'Privaatsusseaded',
    bannerTitleWithCompany: '{company} - Privaatsusseaded',
    bannerText: 'Kasutame küpsiseid ja sarnaseid tehnoloogiaid liikluse analüüsimiseks ja reklaamide isikupärastamiseks. Teie andmeid võidakse jagada meie partneritega. Saate oma nõusolekut igal ajal muuta.',
    learnMore: 'Küpsiste poliitika',
    acceptAll: 'Nõustu kõigiga',
    rejectAll: 'Keeldu kõigist',
    settings: 'Kohanda',
    settingsTitle: 'Küpsiste seaded',
    settingsIntro: 'Valige, milliseid küpsiseid soovite lubada. Vajalikke küpsiseid ei saa keelata - need on veebisaidi toimimiseks vajalikud. Saate oma valikuid igal ajal muuta, klõpsates all vasakul asuval ikoonil.',
    necessary: 'Vajalikud',
    necessaryDesc: 'Need küpsised on vajalikud veebisaidi põhifunktsioonide jaoks nagu sisselogimine, ostukorv või turvalisus. Veebisait ei saa ilma nendeta korralikult toimida.',
    analytics: 'Analüütilised',
    analyticsDesc: 'Aitavad meil mõista, kuidas te veebisaiti kasutate - milliseid lehti külastate, kui kaua jääte. Andmeid kasutatakse veebisaidi parandamiseks.',
    marketing: 'Turundus',
    marketingDesc: 'Võimaldavad kuvada teie huvidele vastavaid reklaame. Andmeid võidakse jagada reklaamipartneritega nagu Google või Meta (Facebook).',
    alwaysActive: 'Alati aktiivne',
    saveSettings: 'Salvesta minu valikud',
    contentBlocked: '{service} sisu on blokeeritud',
    allowService: 'Luba {service}',
    cookieSettings: 'Halda küpsiseid',
  },

  // Latvian
  lv: {
    bannerTitle: 'Privātuma iestatījumi',
    bannerTitleWithCompany: '{company} - Privātuma iestatījumi',
    bannerText: 'Mēs izmantojam sīkdatnes un līdzīgas tehnoloģijas, lai analizētu datplūsmu un personalizētu reklāmas. Jūsu dati var tikt kopīgoti ar mūsu partneriem. Jūs varat mainīt savu piekrišanu jebkurā laikā.',
    learnMore: 'Sīkdatņu politika',
    acceptAll: 'Pieņemt visas',
    rejectAll: 'Noraidīt visas',
    settings: 'Pielāgot',
    settingsTitle: 'Sīkdatņu iestatījumi',
    settingsIntro: 'Izvēlieties, kuras sīkdatnes vēlaties atļaut. Nepieciešamās sīkdatnes nevar atspējot - tās ir nepieciešamas vietnes darbībai. Jūs varat mainīt savas izvēles jebkurā laikā, noklikšķinot uz ikonas apakšējā kreisajā stūrī.',
    necessary: 'Nepieciešamās',
    necessaryDesc: 'Šīs sīkdatnes ir nepieciešamas vietnes pamatfunkcijām, piemēram, pieteikšanās, iepirkumu grozs vai drošība. Vietne nevar pareizi darboties bez tām.',
    analytics: 'Analītiskās',
    analyticsDesc: 'Palīdz mums saprast, kā jūs izmantojat vietni - kādas lapas apmeklējat, cik ilgi paliekat. Dati tiek izmantoti vietnes uzlabošanai.',
    marketing: 'Mārketinga',
    marketingDesc: 'Ļauj rādīt reklāmas, kas atbilst jūsu interesēm. Dati var tikt kopīgoti ar reklāmas partneriem, piemēram, Google vai Meta (Facebook).',
    alwaysActive: 'Vienmēr aktīvs',
    saveSettings: 'Saglabāt manas izvēles',
    contentBlocked: '{service} saturs ir bloķēts',
    allowService: 'Atļaut {service}',
    cookieSettings: 'Pārvaldīt sīkdatnes',
  },

  // Lithuanian
  lt: {
    bannerTitle: 'Privatumo nustatymai',
    bannerTitleWithCompany: '{company} - Privatumo nustatymai',
    bannerText: 'Naudojame slapukus ir panašias technologijas srautui analizuoti ir reklamoms personalizuoti. Jūsų duomenys gali būti dalijami su mūsų partneriais. Savo sutikimą galite pakeisti bet kuriuo metu.',
    learnMore: 'Slapukų politika',
    acceptAll: 'Priimti visus',
    rejectAll: 'Atmesti visus',
    settings: 'Pritaikyti',
    settingsTitle: 'Slapukų nustatymai',
    settingsIntro: 'Pasirinkite, kuriuos slapukus norite leisti. Būtinų slapukų išjungti negalima - jie reikalingi svetainės veikimui. Savo pasirinkimus galite pakeisti bet kuriuo metu spustelėję piktogramą apatiniame kairiajame kampe.',
    necessary: 'Būtini',
    necessaryDesc: 'Šie slapukai yra būtini pagrindinėms svetainės funkcijoms, tokioms kaip prisijungimas, pirkinių krepšelis ar saugumas. Svetainė negali tinkamai veikti be jų.',
    analytics: 'Analitiniai',
    analyticsDesc: 'Padeda mums suprasti, kaip naudojatės svetaine - kokius puslapius lankote, kiek laiko liksite. Duomenys naudojami svetainės tobulinimui.',
    marketing: 'Rinkodaros',
    marketingDesc: 'Leidžia rodyti jūsų interesus atitinkančias reklamas. Duomenimis gali būti dalijamasi su reklamos partneriais, tokiais kaip Google ar Meta (Facebook).',
    alwaysActive: 'Visada aktyvus',
    saveSettings: 'Išsaugoti mano pasirinkimus',
    contentBlocked: '{service} turinys užblokuotas',
    allowService: 'Leisti {service}',
    cookieSettings: 'Tvarkyti slapukus',
  },
};
